// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"139174df","231":"85a61d20","235":"31b210fa","265":"da79fe97","494":"813d4e06"}[chunkId] + ".css";
};